export default "__VITE_ASSET__DSgVnlUk__"